const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Collaborator Picker Behavior
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignCollaborators', ['Users', function(Users) {
    return {
      restrict: 'E',
      scope: {
        collaborators: '=',
        onChange: '&?'
      },
      template: require('../../templates/directives/assign-collaborators.html'),
      controller: ['$scope', '$window', function($scope, $window) {
          var self = this;

          self.helpers = {
            getLocation: function(user) {
              if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
                return user.linked_locations[0].name;
              }
              return '-----';
            },
            getDepartment: function(user) {
              if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
                return user.linked_departments[0].name;
              }
              return '-----';
            },
            getTeams: function(user) {
              if (user && user.linked_teams) {
                var steams = '';
                user.linked_teams.forEach(function(team) {
                  steams += team.name + ',';
                });
                return steams.slice(-1);
              }
              return '-----';
            },
            getOrgLevel: function(user) {
              if (user && user.linked_org_level) {
                return user.linked_org_level.name;
              }
              return '-----';
            },
            getGrade: function(user) {
              if (user && user.linked_grade) {
                return user.linked_grade.name;
              }
              return '-----';
            }
          };

          self.queried = {
            show: false,
            allowNext: true,
            noMatch: false,
            users: [],
            query: {},
            restrictions: {role: 'user'},
            getStandardQuery: function() {
              var q = {
                subresource: '',
                page: 1,
                per_page: 10,
                fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
                role: 'user',
                'linked_locations-populate': 'name',
                'linked_departments-populate': 'name',
                'linked_teams-populate': 'name',
                'linked_org_level-populate': 'name',
                'linked_grade-populate': 'name'
              };
              return q;
            },
            onQuery: function(opts) {
              self.queried.query = self.queried.getStandardQuery();
              if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
                self.queried.noMatch = false;
                self.queried.load();
                return;
              }
              self.queried.noMatch = true;

              self.queried.query.page = 1;
              for (var key in opts) {
                self.queried.query[key] = opts[key];
              }

              self.queried.load();
            },
            load: function(denied) {
              self.queried.loading = true;
              self.queried.allowNext = true;
              Users.find(self.queried.query, function(users) {
                self.queried.loading = false;
                if (users.length < self.queried.query.per_page) {
                  self.queried.allowNext = false;
                  if (!users.length && self.queried.query.page > 1) {
                    console.log('revert');
                    self.queried.query.page--;
                    self.queried.load(true);
                    return;
                  }
                }
                self.queried.users = users;
                if (denied) {
                  self.queried.allowNext = false;
                }
              }, function(error) {
                console.log('Error getting users:', error);
              });
            },
            nextPage: function() {
              if (!self.queried.allowNext) {
                return;
              }
              self.queried.query.page++;
              self.queried.load();
            },
            previousPage: function() {
              if (self.queried.query.page < 2) {
                return;
              }
              self.queried.query.page--;
              self.queried.load();
            }
          };

          self.selected = {
            users: [],
            isSelected: function(user) {
              if (!user || !user._id || !$scope.collaborators || !$scope.collaborators.length) {
                return false;
              }
              return $scope.collaborators.indexOf(user._id) !== -1;
            },
            select: function(user) {
              if (!user || !user._id || self.selected.isSelected(user)) {
                return;
              }
              $scope.collaborators.push(user._id);
              self.selected.load();
              if ($scope.onChange) {
                $scope.onChange();
              }
            },
            remove: function(user) {
              if (!user || !user._id || !$scope.collaborators || !$scope.collaborators.length || !self.selected.isSelected(user)) {
                return;
              }
              for (var i = 0; i < $scope.collaborators.length; i++) {
                if ($scope.collaborators[i] === user._id) {
                  $scope.collaborators.splice(i, 1);
                  self.selected.load();
                  if ($scope.onChange) {
                    $scope.onChange();
                  }
                  return;
                }
              }
            },
            load: function() {
              self.selected.loading = true;
              Users.find({
                subresource: '',
                page: 1,
                per_page: 20,
                fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
                'linked_locations-populate': 'name',
                'linked_departments-populate': 'name',
                'linked_teams-populate': 'name',
                'linked_org_level-populate': 'name',
                'linked_grade-populate': 'name',
                role: 'user',
                _id: '$in,' + $scope.collaborators.length + ',' + $scope.collaborators.join(',')
              }, function(users) {
                self.selected.users = users;
                self.selected.loading = false;
              }, function(error) {
                console.log('Error getting users:', error);
              });
            }
          };

          self.initialize = function() {
            if (!$scope.collaborators) {
              var deregister_collaborators = $scope.$watch('collaborators', function(newVal, oldVal) {
                if (!newVal || newVal === oldVal) {
                  return;
                }
                self.queried.show = !$scope.collaborators.length;
                self.selected.load();
                deregister_collaborators();
              });
              return;
            }
            self.queried.show = !$scope.collaborators.length;
            self.selected.load();
          };

          self.initialize();
        }],
      controllerAs: 'assigner'
    };
  }]);